import { types, actions } from './requests'
export const GETSCHEDULE_TYPES = {
    ...types('GETSCHEDULE'),
}
export const GETSCHEDULE_ACTIONS = {
    ...actions('GETSCHEDULE'),
}